'use es6';

import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DeprecationMessage = ({
  message,
  dashboardId
}) => {
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `reporting-ui-components.deprecation.${message}`,
    options: {
      urlBase: getFullUrl('app'),
      dashboardId: I18n.SafeString(dashboardId),
      portalId: I18n.SafeString(PortalIdParser.get())
    }
  });
};
export default DeprecationMessage;